import React, { FC } from 'react';
import { AppBar, Grid, IconButton, Toolbar } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { Logo } from '../Logo';
import { useStyles } from './styles';
import { NotificationsMenu } from '../NotificationsMenu';

interface Props {
  translation: any;
  handleShowMenu: () => void;
}

export const MobileHeader: FC<Props> = ({ translation, handleShowMenu }) => {
  const classes = useStyles();

  return (
    <Grid container direction="row" className={classes.mobileHeader}>
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar className={classes.mobileToolbar}>
          <Grid item>
            <Logo translation={translation} />
          </Grid>
          <Grid item>
            <Grid container direction="row-reverse" alignContent="center" alignItems="center">
              <Grid item>
                <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleShowMenu}>
                  <Menu />
                </IconButton>
              </Grid>
              <Grid item>
                <NotificationsMenu />
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </Grid>
  );
};
